import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import PhotoGridViewerActionButton from '../../../../../../../components/grid/components/PhotoGridViewerActionButton';
import TrashIcon from '../../../../../../../components/icons/TrashIcon';
import CheckmarkIcon from '../../../../../../../components/icons/CheckmarkIcon';

const propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
};

const AlbumReviewPhotoViewerActions = ({ photo, onDelete, onPublish }) => {
  if (!photo) {
    return null;
  }

  return (
    <Fragment>
      <PhotoGridViewerActionButton
        label="Publish"
        className=""
        icon={
          <div className="album-review-photo-actions-btn">
            <CheckmarkIcon color="#FFF" size={16} />
          </div>
        }
        onClick={onPublish}
      />

      <PhotoGridViewerActionButton
        label="Delete"
        icon={
          <div className="album-review-photo-actions-btn album-review-photo-actions-delete">
            <TrashIcon color="#FFF" size={16} />
          </div>
        }
        onClick={onDelete}
      />
    </Fragment>
  );
};

AlbumReviewPhotoViewerActions.propTypes = propTypes;

export default AlbumReviewPhotoViewerActions;
